import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import { Calendar } from 'owa-calendar-cache';

export const replaceCalendar = mutatorAction(
    'replaceCalendar',
    (newCalendar: Calendar, indexToReplace: number) => {
        const calendars = getStore().calendars;
        calendars.splice(indexToReplace, 1, newCalendar);
    }
);
